import axios from "axios";
import { get, forEach, keys } from "lodash";
import { set as setFP } from "lodash/fp";
import { getPath, getProp, execSurveyDeep } from "../utils/SurveyUtils";
import { getResponseFromSurvey } from "../utils/ServerParser";
import loadSurvey from "../utils/SurveyLoader";

export const CHECK_ERROR = "CHECK_ERROR";
export const CHECK_ERROR_FP = "CHECK_ERROR_FP";
export const CHECK_COMPLETED = "CHECK_COMPLETED";
export const SET_VALUE = "SET_VALUE";
export const SET_VALUE_GLOBAL = "SET_VALUE_GLOBAL";
export const SET_VALIDATE_SECTION = "SET_VALIDATE_SECTION";
export const SET_VALUE_DATE = "SET_VALUE_DATE";
export const RESET_QUESTION = "RESET_QUESTION";
export const VALIDATE_SECTION = "VALIDATE_SECTION";
export const FETCH_SURVEY = "FETCH_SURVEY";
export const RESET_VALUE = "RESET_VALUE";
export const GET_POSTAL_CODE = "GET_POSTAL_CODE";
export const TOGGLE_BT_NEXT = "TOGGLE_BT_NEXT";
export const ADD_PREVIOUS_SECTION = "ADD_PREVIOUS_SECTION";
export const POP_PREVIOUS_SECTION = "POP_PREVIOUS_SECTION";
export const SET_SURVEY = "SET_SURVEY";
export const SET_ID = "SET_ID";
export const SET_CAISSE = "SET_CAISSE";
export const SET_FILLEUL = "SET_FILLEUL";
export const RESET_FILLEULS = "RESET_FILLEULS";
export const REMOVE_FILLEUL = "REMOVE_FILLEUL";

// toutes les mutations sont appelées ici
const actions = {
  checkError({ commit }, data) {
    commit(CHECK_ERROR, data);
  },
  checkErrorFP({ commit }, data) {
    commit(CHECK_ERROR_FP, data);
  },
  resetValue({ commit }, data) {
    commit(RESET_VALUE, data);
  },
  setValue({ commit }, data) {
    commit(SET_VALUE, data);
  },
  setValueGlobal({ commit }, data) {
    commit(SET_VALUE_GLOBAL, data);
  },
  setValidateSection({ commit }, data) {
    commit(SET_VALIDATE_SECTION, data);
  },
  setValueDate({ commit }, data) {
    commit(SET_VALUE_DATE, data);
  },
  resetQuestion({ commit }, data) {
    commit(RESET_QUESTION, data);
  },
  validateSection({ commit }, data) {
    commit(VALIDATE_SECTION, data);
  },
  checkCompleted({ commit }, data) {
    commit(CHECK_COMPLETED, data);
  },
  fetchSurvey({ commit }, data) {
    commit(FETCH_SURVEY, data);
  },
  getAllPostalCode({ commit }) {
    commit(GET_POSTAL_CODE);
  },
  sendSurvey({ commit }, data) {
    let survey = data.survey;
    let responses = {};
    execSurveyDeep(survey, (s, sn) => {
      if (s.serverPathValidated && get(survey, `sections.${sn}.isValidated`) === true) {
        responses = setFP(s.serverPathValidated, true, responses);
      }
    }, (q, p, rp) => {
      const serverPath = getProp(q, "serverPath", rp);
      if (serverPath) {
        const values = getResponseFromSurvey[q.questionType](
          survey,
          getPath(p, rp, "response"),
          serverPath,
          q.resetServerPath,
        );
        if (values) {
          if (typeof values === "object" && keys(values).length > 0) {
            forEach(values, (value, path) => {
              if (value && path) {
                responses = setFP(path, value, responses);
              }
            });
          } else {
            if (values && serverPath) {
              responses = setFP(serverPath, values, responses);
            }
          }
        }
      }
    });
    console.log("/..../", responses);
    console.log("/data/", data);
    axios.post(`${process.env.VUE_APP_API_URL}/formreco/setclient`, {
      ...responses, 
      Origin: data?.query?.origin || ""
    })
    .then(({ data }) => {
      const Newdata = { ...data, id: responses.CodeClient };
      commit(SET_ID, Newdata);
    })
    .catch(e => console.log(e));
  },
  toggleBtNext({ commit }, data) {
    commit(TOGGLE_BT_NEXT, data);
  },
  addPreviousSection({ commit }, data) {
    commit(ADD_PREVIOUS_SECTION, data);
  },
  popPreviousSection({ commit }, data) {
    commit(POP_PREVIOUS_SECTION, data);
  },
  setSurvey({ commit }, data) {
    commit(SET_SURVEY, data);
  },
  setFilleulState({ commit }, data) {
    commit(SET_FILLEUL, data);
  },
  resetFilleulsState({ commit }, data) {
    commit(RESET_FILLEULS, data);
  },
  removeFilleulState({ commit }, data) {
    commit(REMOVE_FILLEUL, data);
  },
  loadSurveyFromUrl({ commit, state }) {
    // Récupérer l'origin actuel depuis l'URL
    const urlParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
    const newOrigin = urlParams?.get("origin") || null;
    
    // Récupérer l'origin stocké dans le survey (si disponible)
    const storedOrigin = state.survey?.sections?.globals?.questions?.origin?.response || null;
    
    // Si le survey n'existe pas ou si l'origin a changé, recharger le survey
    if (!state.survey || storedOrigin !== newOrigin) {
      // Préserver les données existantes avant rechargement
      const preservedData = state.survey ? {
        nombreFilleuls: state.survey.sections.globals.nombreFilleuls,
        filleulsResponses: {}, // Préserver seulement les réponses, pas les questions
        responses: {}
      } : null;
      
      // Préserver les réponses des filleuls existantes
      if (state.survey && state.survey.sections.forms.questions.filleuls.questions) {
        Object.keys(state.survey.sections.forms.questions.filleuls.questions).forEach(filleulId => {
          const filleul = state.survey.sections.forms.questions.filleuls.questions[filleulId];
          preservedData.filleulsResponses[filleulId] = {};
          if (filleul.questions) {
            Object.keys(filleul.questions).forEach(field => {
              const fieldData = filleul.questions[field];
              if (fieldData.response !== undefined) {
                preservedData.filleulsResponses[filleulId][field] = fieldData.response;
              }
            });
          }
        });
      }
      
      // Préserver les autres réponses existantes
      if (state.survey) {
        const preserveResponses = (obj, path = '') => {
          Object.keys(obj).forEach(key => {
            const fullPath = path ? `${path}.${key}` : key;
            if (obj[key] && typeof obj[key] === 'object' && obj[key].response !== undefined) {
              // Ne pas préserver les réponses des filleuls ici, c'est fait séparément
              if (!fullPath.includes('filleuls.questions')) {
                preservedData.responses[fullPath] = obj[key].response;
              }
            } else if (obj[key] && typeof obj[key] === 'object' && !obj[key].response) {
              preserveResponses(obj[key], fullPath);
            }
          });
        };
        preserveResponses(state.survey.sections);
      }
      
      let survey = loadSurvey(); // récupère le survey selon l'URL
      
      // Restaurer les données préservées
      if (preservedData) {
        survey.sections.globals.nombreFilleuls = preservedData.nombreFilleuls;
        
        // Recréer les questions des filleuls avec la nouvelle configuration
        if (preservedData.nombreFilleuls > 0) {
          // Recréer chaque filleul avec les bonnes règles
          Object.keys(preservedData.filleulsResponses).forEach(filleulId => {
            const responses = preservedData.filleulsResponses[filleulId];
            const filleulLabelSingular = get(survey, "sections.globals.filleulLabels.singular", "Votre filleul");
            const emailRequired = get(survey, "sections.globals.filleulEmailRequired", true);
            
            const filleul = {
              "label": filleulLabelSingular,
              "questionClass": "col-12 form-filleul",
              "questions": {
                "nom": {
                  "serverPath": `Filleuls.${filleulId}.Nom`,
                  "questionType": "input",
                  "labelInput": "Nom *",
                  "questionClass": "col-12 col-md-4",
                  "rules": {
                    "required": "Merci de renseigner son nom.",
                    "alphaName": "Merci de vérifier votre saisie."
                  }
                },
                "prenom": {
                  "serverPath": `Filleuls.${filleulId}.Prenom`,
                  "labelInput": "Prénom *",
                  "questionType": "input",
                  "questionClass": "col-12 col-md-4",
                  "rules": {
                    "required": "Merci de renseigner son prénom.",
                    "alphaName": "Merci de vérifier votre saisie."
                  }
                },
                "ville": {
                  "serverPath": `Filleuls.${filleulId}.Ville`,
                  "labelInput": "CP Ville *",
                  "optionsURL": "FormReco/getCpVille",
                  "questionType": "select",
                  "questionClass": "col-12 col-md-4",
                  "rules": {
                    "required": "Merci de renseigner son code postal-ville."
                  }
                },
                "email": (() => {
                  const emailRules = {
                    "email": "Merci de vérifier votre saisie."
                  };
                  if (emailRequired) {
                    emailRules["required"] = "Merci de renseigner son adresse email.";
                  }
                  return {
                    "serverPath": `Filleuls.${filleulId}.Email`,
                    "labelInput": emailRequired ? "Email *" : "Email",
                    "questionType": "input",
                    "questionClass": "col-12 col-md-4",
                    "rules": emailRules
                  };
                })(),
                "telephone": {
                  "serverPath": `Filleuls.${filleulId}.noTelephone`,
                  "labelInput": "Téléphone *",
                  "questionClass": "col-12 col-md-4",
                  "questionType": "cleave",
                  "cleaveOptions": {
                    "blocks": [2, 2, 2, 2, 2]
                  },
                  "rules": {
                    "required": "Merci de renseigner son numéro de téléphone.",
                    "regexp": {
                      "model": "^[0-9]{10}$",
                      "message": "Merci de vérifier votre saisie."
                    }
                  }
                },
                "removeFilleul": {
                  "id": filleulId,
                  "questionType": "removeFilleul",
                  "buttonLabel": "Annuler l'ajout",
                  "visibilityRules": {
                    "sections.globals.nombreFilleuls": {
                      "greater": 1
                    }
                  }
                }
              }
            };
            
            survey = setFP(`sections.forms.questions.filleuls.questions.${filleulId}`, filleul, survey);
            
            // Restaurer les réponses pour ce filleul
            Object.keys(responses).forEach(field => {
              if (filleul.questions[field]) {
                filleul.questions[field].response = responses[field];
              }
            });
          });
        }
        
        // Restaurer les autres réponses
        const restoreResponses = (obj, path = '') => {
          Object.keys(obj).forEach(key => {
            const fullPath = path ? `${path}.${key}` : key;
            if (preservedData.responses[fullPath] !== undefined) {
              obj[key].response = preservedData.responses[fullPath];
            } else if (obj[key] && typeof obj[key] === 'object') {
              restoreResponses(obj[key], fullPath);
            }
          });
        };
        restoreResponses(survey.sections);
      }
      
      // Sauvegarder l'origin dans le survey pour la prochaine vérification
      if (newOrigin && survey.sections.globals.questions.origin) {
        survey.sections.globals.questions.origin.response = newOrigin;
      }
      commit(SET_SURVEY, survey);
      return true; // Indique que le survey a été rechargé
    }
    return false; // Le survey n'a pas changé
  }
};

export default actions;
